export default "__VITE_ASSET__DjdR$Eja__"